module.exports = __webpack_public_path__ + "static/media/ab.8a6a4312.png";